export default __webpack_public_path__ + "static/media/gallery_09.15a3e2d3.jpg";